function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m50.667 5.3341h-24.117a13.242 13.242 0 0 0-10.522 5.1492l-15.466 19.879a2.6666 2.6666 0 0 0 0 3.2746l15.466 19.879a13.242 13.242 0 0 0 10.522 5.1492h24.117a13.349 13.349 0 0 0 13.333-13.333v-26.666a13.349 13.349 0 0 0-13.333-13.333zm7.9998 39.999a7.9998 7.9998 0 0 1-7.9998 7.9998h-24.117a7.9438 7.9438 0 0 1-6.3145-3.0879l-14.189-18.245 14.189-18.245a7.9438 7.9438 0 0 1 6.3145-3.0879h24.117a7.9998 7.9998 0 0 1 7.9998 7.9998zm-12.781-18.114-4.7812 4.7812 4.7812 4.7812a2.6666 2.6666 0 1 1-3.7706 3.7706l-4.7812-4.7812-4.7812 4.7812a2.6666 2.6666 0 1 1-3.7706-3.7706l4.7812-4.7812-4.7812-4.7812a2.6666 2.6666 0 1 1 3.7706-3.7706l4.7812 4.7812 4.7812-4.7812a2.6666 2.6666 0 1 1 3.7706 3.7706z",
    style: {
      strokeWidth: 2.6666
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b3f2b9bf.svg";
export { ForwardRef as ReactComponent };